"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useState } from "react";
export function useVideoElementState(videoRef, playbackRate) {
  const $ = _c(13);
  const [isPlaying, setIsPlaying] = useState(true);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [rate, setRateState] = useState(1);
  let t0;
  let t1;
  if ($[0] !== videoRef) {
    t0 = () => {
      const video = videoRef.current;
      if (!video) {
        return;
      }
      const sync = () => {
        setIsPlaying(!video.paused);
        if (Number.isFinite(video.duration)) {
          setDuration(video.duration);
        }
      };
      const onTimeUpdate = () => {
        setCurrentTime(video.currentTime);
      };
      const onRateChange = () => {
        setRateState(video.playbackRate);
      };
      sync();
      onRateChange();
      video.addEventListener("play", sync);
      video.addEventListener("pause", sync);
      video.addEventListener("loadedmetadata", sync);
      video.addEventListener("timeupdate", onTimeUpdate);
      video.addEventListener("ratechange", onRateChange);
      return () => {
        video.removeEventListener("play", sync);
        video.removeEventListener("pause", sync);
        video.removeEventListener("loadedmetadata", sync);
        video.removeEventListener("timeupdate", onTimeUpdate);
        video.removeEventListener("ratechange", onRateChange);
      };
    };
    t1 = [videoRef];
    $[0] = videoRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== playbackRate || $[4] !== videoRef) {
    t2 = () => {
      const video_0 = videoRef.current;
      if (!video_0 || playbackRate === undefined) {
        return;
      }
      video_0.playbackRate = playbackRate;
    };
    t3 = [videoRef, playbackRate];
    $[3] = playbackRate;
    $[4] = videoRef;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== currentTime || $[8] !== duration || $[9] !== isPlaying || $[10] !== rate || $[11] !== videoRef) {
    t4 = {
      currentTime,
      duration,
      isPlaying,
      rate,
      seek(time) {
        const video_1 = videoRef.current;
        if (!video_1) {
          return;
        }
        video_1.currentTime = time;
        setCurrentTime(time);
      },
      setRate(value) {
        const video_2 = videoRef.current;
        if (video_2) {
          video_2.playbackRate = value;
        }
      },
      toggle() {
        const video_3 = videoRef.current;
        if (!video_3) {
          return;
        }
        if (video_3.paused) {
          video_3.play().catch(_temp);
        } else {
          video_3.pause();
        }
      }
    };
    $[7] = currentTime;
    $[8] = duration;
    $[9] = isPlaying;
    $[10] = rate;
    $[11] = videoRef;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp() {}